function dragstartHandler(ev) {
  ev.originalEvent.dataTransfer.setData("text", ev.target.id);
}

function dragoverHandler(ev) {
  ev.preventDefault();
}

function tenantDropHandler(ev) {
  ev.preventDefault();

  let data = ev.originalEvent.dataTransfer.getData("text");
  let elm = $("#" + data);
  let wasTenant = elm.parent().hasClass("tenant");

  if(wasTenant) return;

  let newRow = $('<div class="row tenant-cosigner"><div class="col-md-3 tenant"></div><div class="col-md-3 cosigner"></div></div>');
  let tennants = $('#tenants');

  tenants.append(newRow[0]);

  let tenant = newRow.find('.tenant');
  let cosigner = newRow.find('.cosigner');

  tenant.append(elm);

  tenant.on("drop", tenantDropHandler);
  cosigner.on("drop", cosignerDropHandler);
}

function cosignerDropHandler(ev) {
  ev.preventDefault();

  let data = ev.originalEvent.dataTransfer.getData("text");
  let elm = $("#" + data);
  let parentRow = elm.parent().parent();
  let destElm = $(ev.currentTarget)
  let destParentRow = destElm.parent();

  if(parentRow.find('.cosigner').children().length > 0) {
    // tenant has a current cosginer, need to remove cosigner first
    return;
  }

  if (destElm.children().length > 0) {
    // dest tenant already has a cosigner
    return;
  }

  if (parentRow[0] === destParentRow[0]) {
    // can't be your own cosigner
    return;
  }

  ev.currentTarget.appendChild(document.getElementById(data));

  parentRow.remove();
}



module.exports = function() {
  $(".application").on("dragstart", dragstartHandler);
  $(".cosigner,.tenant").on("dragover", dragoverHandler);
  $(".tenant").on("drop", tenantDropHandler);
  $(".cosigner").on("drop", cosignerDropHandler);

  $('#new_lease').submit(function (evt) {
    $('.tenant-cosigner').each(function (index, tc) {
      let tenant = $(tc).find('.tenant .application').data('application-id');
      let cosigner = $(tc).find('.cosigner .application').data('application-id');
      $("<input />").attr("type", "hidden")
            .attr("name", "lease[tenants_applications][][person_id]")
            .attr("value", tenant)
            .appendTo(this);
      $("<input />").attr("type", "hidden")
            .attr("name", "lease[tenants_applications][][cosigner_id]")
            .attr("value", cosigner)
            .appendTo(this);
    });

    return true;
  });
}